import { DTOQueue, DTOQueueResponse } from "./Queue/Queue.interface";
import axiosBase from "./axiosBase";

export const callQueue = async (input: DTOQueue) => {
  // console.log("callQueue: input:", input);
  const response = await axiosBase.post<DTOQueueResponse>("/queue", input);
  return response.data;
};
